/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How long should I steep green tea?`)
};

const es_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuánto tiempo debo dejar en infusión el té verde?`)
};

const de_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie lange sollte ich grünen Tee ziehen lassen?`)
};

const nl_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe lang moet ik groene thee laten trekken?`)
};

const fr_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien de temps faut-il infuser le thé vert ?`)
};

const it_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo dovrei lasciare in infusione il tè verde?`)
};

const pt_br2_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por quanto tempo devo deixar o chá verde em infusão?`)
};

const pt_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto tempo devo deixar o chá verde em infusão?`)
};

const ja_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`緑茶はどのくらい浸出させればいいですか？`)
};

const zh_timer_u2m_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绿茶应该冲泡多久？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_faq4_q", locale)
	if (locale === "en") return en_timer_u2m_faq4_q(inputs)
	if (locale === "es") return es_timer_u2m_faq4_q(inputs)
	if (locale === "de") return de_timer_u2m_faq4_q(inputs)
	if (locale === "nl") return nl_timer_u2m_faq4_q(inputs)
	if (locale === "fr") return fr_timer_u2m_faq4_q(inputs)
	if (locale === "it") return it_timer_u2m_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_faq4_q(inputs)
	if (locale === "pt") return pt_timer_u2m_faq4_q(inputs)
	if (locale === "ja") return ja_timer_u2m_faq4_q(inputs)
	return zh_timer_u2m_faq4_q(inputs)
};